export const statusChipColors = [
  'success',
  'neutral',
  'info',
  'warning',
  'error',
] as const;

export const statusChipSizes = ['small', 'medium', 'large'] as const;
export const statusChipVariants = ['subtle', 'strong'] as const;
